//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { ConfirmationModalActions } from '@account-settings/redux/facebook-instagram/confirmation-modal/confirmationModalActions';
import {
  CONFIRMATION_MODAL_ACTIONS,
  IConfirmationModalState,
} from '@account-settings/redux/facebook-instagram/confirmation-modal/confirmationModalModel';

const initialState: IConfirmationModalState = {
  isDisconnectModalOpen: false,
  isIgConfirmationModalOpen: false,
  isRefreshConfirmationModalOpen: false,
};

export default function ConfirmationModalReducer(
  state: IConfirmationModalState = initialState,
  action: ConfirmationModalActions,
): IConfirmationModalState {
  switch (action.type) {
    case CONFIRMATION_MODAL_ACTIONS.TOGGLE_DISCONNECT_MODAL:
      return {
        ...state,
        isDisconnectModalOpen: !state.isDisconnectModalOpen,
      };
    case CONFIRMATION_MODAL_ACTIONS.TOGGLE_IG_CONFIRMATION_MODAL:
      return {
        ...state,
        isIgConfirmationModalOpen: !state.isIgConfirmationModalOpen
      };
    case CONFIRMATION_MODAL_ACTIONS.TOGGLE_REFRESH_CONFIRMATION_MODAL:
      return {
        ...state,
        isRefreshConfirmationModalOpen: !state.isRefreshConfirmationModalOpen
      };
    default:
      return state;
  }
}
